// packages import
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Box, IconButton, Skeleton, Typography } from '@mui/material'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
// others
import { NOT_APPLICABLE } from '../../constants'
import { HeaderPropType } from '../../interfaceTypes'

export const DetailPageHeader: FC<HeaderPropType> = ({ loading, title, backLink }): JSX.Element => {
  const navigate = useNavigate()

  return (
    <Box display="flex" alignItems="center" mt={2} gap={2}>
      <IconButton onClick={() => (backLink ? navigate(backLink) : navigate(-1))} aria-label="back">
        <ArrowBackIcon color="primary" />
      </IconButton>

      <Box minHeight="62px" display="flex" alignItems="center" minWidth={0}>
        {loading ? (
          <Skeleton variant="text" width={220} height={42} />
        ) : (
          <Typography fontWeight={400} fontSize="20px" py={2} color="secondary.main" sx={{ overflowWrap: 'anywhere' }}>
            {title || NOT_APPLICABLE}
          </Typography>
        )}
      </Box>
    </Box>
  )
}
